module.exports = __webpack_public_path__ + "assets/Upsilon.59bf4fd4bdea091dacb6aa78d7025b28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Upsilon.png
// module id = 849
// module chunks = 0